import { Managers } from './Managers';

export default Managers;
